import axios from 'axios'
import { toSnakeCase, toCamelCase } from './data-format'
import { getToken,setToken,removeAll,removeToken } from '@/utils/auth'
import { Message } from 'element-ui';
import store from '@/store'
import { refreshAccessToken,  } from '@/api/security'
const http = axios.create({
  baseURL:  process.env.VUE_APP_BASE_API,
  timeout: 30000
})
 
http.interceptors.request.use(
  config => {
    const token = getToken()
    config.headers.common['Authorization'] = `Bearer ${token}`
    config.headers.common['accept-language'] = `zh_tc`
    if (!config.unformat) {
      config.params = toSnakeCase(config.params)
      config.data = toSnakeCase(config.data)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  response => {
    if (response.headers['content-type'] === 'application/json') {
      response.data = toCamelCase(response.data)
    }
    return response
  },
  error => {
    if (error.response.status === 401) {
      let refreshToken = {
        refreshToken: store.getters.adminUserInfo && store.getters.adminUserInfo.refreshToken
      }
      refreshAccessToken(refreshToken).then(res => {
        setToken(res.data.accessToken);
      }).catch(()=>{
        removeToken();
        removeAll();
        store.dispatch("setAdminUserInfo",null);
        location.reload();
      })
    }  else if (error.response.status === 500) {      
      Message.error(error.response.data.message);
    }   else {
      Message.error(error.response.data.error_message);
    }
    return Promise.reject(error)
  }
)

export default http
